import React from "react";
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { MonthlyTrend } from "../attendance.types";
import LoadingSkeleton from "../../common/loading-skeleton/loading-skeleton";

interface IProps {
    data: MonthlyTrend[];
    isLoading: boolean;
}

const MonthlyAttendanceChart = (props: IProps) => {

    const monthlyAttendanceChartData = props.data.map((val) => ({
        name: val.month,
        ...val

    }));

    return (
        <section className="pn-attendance__card line-chart-wrapper">
            <div className="pn-attendance__card__header">
                <h3 className="pn-attendance__card__title">Monthly Attendance Trend</h3>
                <span className="pn-attendance__card__subtitle">Organization-wide rate over the last 6 months</span>
            </div>
            <LoadingSkeleton loading={props.isLoading}>
                <ResponsiveContainer width="100%" height={240}>
                    <LineChart
                        data={monthlyAttendanceChartData}
                        margin={{
                            top: 5,
                            right: 5,
                            left: 5,
                            bottom: 5,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3" stroke="var(--pn-border)"/>
                        <XAxis
                            width={20}
                            tick={{
                                fontSize: 12,
                                fill: "var(--pn-text-primary)",
                            }}
                            dataKey="name"
                            stroke="var(--pn-text-primary)"
                        />
                        <YAxis width={30}
                               tick={{
                                   fontSize: 12,
                                   fill: "var(--pn-text-primary)",
                               }}
                               stroke="var(--pn-text-primary)"
                        />
                        <Tooltip
                            cursor={{
                                stroke: 'var(--pn-text-secondary)',
                            }}
                            contentStyle={{
                                backgroundColor: 'var(--pn-bg-card)',
                                border: '1px solid var(--pn-border)',
                                borderRadius: '8px',
                                padding: '8px',
                                fontSize: '12px',
                                color: 'var(--pn-text-primary)'
                            }}
                        />
                        <Legend
                            verticalAlign="top"
                            align="center"
                            height={36}
                        />
                        <Line
                            type="monotone"
                            dataKey="presentPercentage"
                            name="Present %"
                            stroke="var(--success-hover)"
                            strokeWidth={2}
                            dot={{
                                fill: 'var(--success-hover)',
                            }}
                            activeDot={{r: 8, stroke: 'var(--success-text)'}}
                        />
                        <Line
                            type="monotone"
                            dataKey="absentPercentage"
                            name="Absent %"
                            stroke="var(--danger-hover)"
                            strokeWidth={2}
                            dot={{
                                fill: 'var(--danger-hover)',
                            }}
                            activeDot={{r: 8, stroke: 'var(--danger-text)'}}
                        />
                        <Line
                            type="monotone"
                            dataKey="onLeavePercentage"
                            name="On Leave %"
                            stroke="var(--warning-hover)"
                            strokeWidth={2}
                            dot={{
                                fill: 'var(--warning-hover)',
                            }}
                            activeDot={{r: 8, stroke: 'var(--warning-text)'}}
                        />


                    </LineChart>
                </ResponsiveContainer>
            </LoadingSkeleton>

        </section>
    )

}

export default MonthlyAttendanceChart;
